export class  ChangeControlSearch{
    eQMSScopes?:string[];
    targetCompletionDates?:string[];
    responsibleSubBUs?:string[];
    phases?:string[];
    categories?:string[];
    searchText?: string;
    users?:string[];
}
